import React, { useEffect } from 'react';

import { Box } from '@material-ui/core';

import {
    useReservationRequestsLoad,
    useReservationsRestaurantId,
    useThunkDispatch,
} from 'components/reservations/hooks';
import { theme } from 'config/theme';
import { useAppSelector } from 'index';
import { SignalREvent, signalRService } from 'services/signalR';
import reservationsStore from 'store/reservationsStore';
import { useStyles } from '../styles';

export default function ReservationRequestsCounter(props: { isOpen: boolean }) {
    const classes = useStyles();
    const dispatch = useThunkDispatch();
    const restaurantId = useReservationsRestaurantId();
    const isLoaded = useAppSelector(
        (state) => restaurantId !== null && state.reservations.requestsRestaurantId === restaurantId
    );
    const count = useAppSelector((state) => state.reservations.requests.length);
    const language = useAppSelector((state) => state.global.language);
    useReservationRequestsLoad();

    useEffect(() => {
        if (!restaurantId) {
            return;
        }
        return signalRService.subscribe(SignalREvent.ReservationRequestsChanged, () =>
            dispatch(reservationsStore.actionCreators.getRequests(restaurantId))
        );
    }, [restaurantId]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!isLoaded || count === 0) {
        return null;
    }

    const openLeft = language === 'en' ? 160 : 175;

    return (
        <Box position="relative">
            <Box
                className={classes.newOrdersCount}
                left={props.isOpen ? openLeft : 35}
                minWidth={12}
                px="3px"
                style={{ backgroundColor: theme.palette.error.light }}
            >
                {count}
            </Box>
        </Box>
    );
}
